<template>
  <div class="promocode-component">
    <div class="promocode-component_header">Промокод</div>

    <div class="promocode-component_border"></div>

    <div class="promocode-component_content">
      <div class="block block__row block__position_relative">
        <input name="promo_code"
               class="promocode-component_input"
               v-model="valuePromoCode"
               :disabled="promoCodeApplied"
               type="text"
               placeholder="Введите промокод"
               @keydown.enter="applyPromoCode()"
        />

        <transition name="fade">
          <div class="button button__type_remove svg"
               v-if="promoCodeApplied"
               @click="removePromoCode()"
          >
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.2502 0L6.99938 5.25L1.74984 0L0 1.75L5.24954 7L0 12.25L1.74984 14L6.99938 8.75L12.2502 14L14 12.25L8.75046 7L14 1.75L12.2502 0Z"
                fill="white" fill-opacity="1"/>
            </svg>
          </div>
        </transition>
      </div>

      <div class="promocode-component_button"
           :class="(!promoCodeApplied && (valuePromoCode.length > 0))?('promo_button__active'):(
                 (promoCodeApplied)?('promo_button__applied'):('')
                 )"
           @click="applyPromoCode()"
      >
        <transition name="out-in">
          <div class="svg promocode-component_svg"
               key="promoCodeApplied"
               v-if="!promoCodeApplied"
          >
            <svg width="22" height="22" viewBox="0 0 18 18"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.98098 9.3431L10.3044 9.0001L9.98098 8.65709L6.6872 5.1637L7.19141 4.62894L11.3128 9.0001L7.19141 13.3712L6.6872 12.8365L9.98098 9.3431Z"
                fill="#ABABB2" stroke="#ABABB2"/>
            </svg>
          </div>

          <div class="svg promocode-component_svg"
               key="promoNotCodeApplied"
               v-else
          >
            <svg width="22" height="22" viewBox="0 0 22 22"
                 fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.98357 13.1016L6.0578 10.1758L5.96499 10.083L5.87218 10.1758L4.57602 11.472L4.48321 11.5648L4.57602 11.6576L8.89077 15.9724L8.98357 16.0652L9.07638 15.9724L17.9745 7.07428L18.0673 6.98147L17.9745 6.88866L16.6783 5.59249L16.5855 5.49969L16.4927 5.59249L8.98357 13.1016Z"
                fill="white" stroke="white" stroke-width="0.2625"/>
            </svg>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobilePromoCodeComponent",

  props: {
    promoCodeApplied: { // применен промокод?
      type: Boolean,
      default: () => {
        return false
      }
    },

    promoCode: { // текст промокода
      type: String,
      default: () => {
        return ''
      }
    },
  },

  data() {
    return {

    }
  },

  created() {
    console.log('promoCode', this.promoCode)
  },

  mounted() {

  },

  watch: {

  },

  methods: {
    /** Применить промокод
     * */
    applyPromoCode() {
      this.$emit('applyPromoCode');
    },

    /** Удалить промокод
     * */
    removePromoCode() {
      this.$emit('removePromoCode');
    },
  },

  computed: {
    valuePromoCode: { // промокод
      get() {
        return this.promoCode
      },

      set(modelValue) {
        this.$emit('update:promoCode', modelValue);
      }
    },
  },

  components: {

  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../../style/variables";

.block__column {
  display: flex;
  flex-direction: column;
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.svg {
  display: flex;
  flex-direction: row ;
  align-items: center;
  justify-content: center;
}

.block__position_relative {
  position: relative;
}

.promocode-component {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid $color_grey_bg_2;
  border-radius: 8px;
}

.promocode-component_header {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: uppercase;
  height: 46px;
  padding: 0 20px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 18px;
  color: $color_grey_4;
}

.promocode-component_border {
  display: flex;
  height: 1px;
  width: 100%;
  background-color: $color_grey_bg_2;
}

.promocode-component_content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: flex-start;
  grid-gap: 16px;
  margin: 16px 20px;
}

.promocode-component_input {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  height: 48px;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  transition: $transition_medium;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 19px;
  color: $color_black;
  outline: none;

  &:focus {
    border-color: $color_purple_3;
  }
}

.promocode-component_input:disabled:hover {
  border-color: rgba(0, 0, 0, 0.08);
}

.button__type_remove {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $color_red_1;
  cursor: pointer;
  position: absolute;
  right: 14px;
  transition: $transition_medium;

  svg {
    width: 10px;
    height: 10px;
  }
}

.promocode-component_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: default;
  width: 48px;
  height: 48px;
  border-radius: 6px;
  transition: $transition_medium;
  background-color: $color_purple_3;

  .promocode-component_svg svg {
    width: 20px;
    height: auto;

    path {
      stroke: white;
    }
  }
}

// mobile
@media all and (max-width: 600px) {
  .promocode-component_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promocode-component_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .promocode-component {
    border-radius: 8px;
  }
  .promocode-component_header {
    height: 42px;
    padding: 0 16px;
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
  }
  .promocode-component_content {
    grid-gap: 10px;
    margin: 14px 16px;
  }

  .promocode-component_input {
    border-radius: 6px;
    height: 44px;
    padding: 0 14px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
  .button__type_remove {
    width: 20px;
    height: 20px;
    right: 10px;

    svg {
      width: 9px;
      height: 9px;
    }
  }
}
</style>